import * as scormAPIWrapper from '../wrappers/scorm/APIWrap';
import * as scormConstants from '../constants/scormConstants';
import * as appData from '../models/appModels';
import * as xAPIConstants from '../constants/xAPIConstants';
import xAPI from '../wrappers/xapi/xAPIWrap';
import * as appHelper from '../helpers/appHelper';
import _ from 'lodash';
import striptags from 'striptags';

class xAPIScormService {

    static initTracking(contentData) {
        return new Promise(function (resolve, reject) {
            let trackingData = Object.assign({}, appData.TRACKING_DATA);
            let suspend_data = trackingData.suspend_data;

            let conf = {
                endpoint : contentData.experience.lrs.end_point,
                user:  contentData.experience.lrs.key,
                password: contentData.experience.lrs.secret,
            };

            let lrs = new xAPI.Lrs(conf);
            lrs.changeConfig(conf);
            let settings = {};

            scormAPIWrapper.doLMSInitialize().then(result => {

                //GET STUDENT_NAME
                scormAPIWrapper.doLMSGetValue(scormConstants.CMI_CORE_STUDENT_NAME).then(result => {
                    if(result.success){
                        let studentNameObj = appHelper.setStudentName(result.data);
                        trackingData = Object.assign({}, trackingData, {
                            student_name: studentNameObj.student_name,
                            first_name: studentNameObj.first_name,
                            last_name: studentNameObj.last_name
                        });
                    }
                }).catch(error => {
                    throw(error);
                });

                //GET STUDENT_ID
                scormAPIWrapper.doLMSGetValue(scormConstants.CMI_CORE_STUDENT_ID).then(result => {
                    if(result.success){
                        trackingData = Object.assign({}, trackingData, {
                            student_id: result.data
                        });
                    }
                }).catch(error => {
                    throw(error);
                });

                //GET LESSON_LOCATION (BOOKMARK)
                scormAPIWrapper.doLMSGetValue(scormConstants.CMI_CORE_LESSON_LOCATION).then(result => {
                    trackingData = Object.assign({}, trackingData, {
                        lesson_location: result.success ? result.data : trackingData.lesson_location
                    });

                }).catch(error => {
                    throw(error);
                });

                //GET LESSON_STATUS
                scormAPIWrapper.doLMSGetValue(scormConstants.CMI_CORE_LESSON_STATUS).then(result => {

                    if (result.data != scormConstants.LESSON_STATUS_COMPLETED) {
                        scormAPIWrapper.doLMSSetValue(scormConstants.CMI_CORE_LESSON_STATUS, scormConstants.LESSON_STATUS_INCOMPLETE);
                        trackingData = Object.assign({}, trackingData, {
                            lesson_status: scormConstants.LESSON_STATUS_INCOMPLETE
                        });
                    }else{
                        trackingData = Object.assign({}, trackingData, {
                            lesson_status: result.success ? result.data : trackingData.lesson_status
                        });
                    }

                }).catch(error => {
                    throw(error);
                });

                //GET SCORE_RAW
                scormAPIWrapper.doLMSGetValue(scormConstants.CMI_CORE_SCORE_RAW).then(result => {
                    trackingData = Object.assign({}, trackingData, {
                        score_raw: result.success && !isNaN(parseInt(result.data)) ? parseInt(result.data) : trackingData.score_raw
                    });
                }).catch(error => {
                    throw(error);
                });


                //FINISH OFF BY MAKING SURE THE LMS IS INITIALISED
                scormAPIWrapper.LMSIsInitialized().then(result => {
                    settings = {
                        student:{
                            id:trackingData.student_id,
                            name: `${trackingData.first_name} ${trackingData.last_name}`,
                            homePage: lrs.getCurrentUrl()
                        },
                        project:{
                            id: `${lrs.getCurrentUrl()}/project_id:${contentData.experience.project_id }`,
                            name: contentData.experience.en.project_title,
                        },
                        activity:{
                            id: `${lrs.getCurrentUrl()}/project_id:${contentData.experience.project_id }/experience_id:${contentData.experience.experience_id}`,
                            name: appHelper.getLocalData(contentData.experience).experience_title,
                            description: appHelper.getLocalData(contentData.experience).experience_title,
                        },
                        conf:{
                            endpoint : xAPIConstants.LRS_END_POINT,
                            user:  xAPIConstants.LRS_KEY,
                            password: xAPIConstants.LRS_SECRET,
                        }
                    };
                    lrs.updateSettings(settings);


                    let user = {
                        account: {
                            name: lrs.settings.student.id,
                            homePage: lrs.settings.student.homePage
                        }
                    };

                    let actor = {
                        objectType: "Agent",
                        name: lrs.settings.student.name,
                        account:user.account,
                    };

                    lrs.lrs.actor = JSON.stringify(actor);

                    function getSuspendData(){
                        lrs.getState(
                            lrs.settings.activity.id,
                            new lrs.Agent(actor, actor.name),
                            "suspend_data")
                        .then(response => {
                            suspend_data = response.suspend_data;

                            trackingData = Object.assign({}, trackingData, {
                                suspend_data: suspend_data
                            });

                            sendLaunchStatement();
                        }).catch(error => {
                            sendLaunchStatement();
                        });
                    }

                    function sendLaunchStatement(){
                        let stmt = new lrs.Statement(
                            new lrs.Agent(actor, actor.name),
                            lrs.Verbs.launched,
                            new lrs.Activity(lrs.settings.activity.id, lrs.settings.activity.name, lrs.settings.activity.description, xAPIConstants.MODULE_ACTIVITY_TYPE)
                        );

                        let group =  {
                            id:`${lrs.settings.project.id}`,
                            objectType: 'Activity',
                            definition: {
                                name: {
                                    en: lrs.settings.project.name
                                },
                                type: xAPIConstants.PROJECT_ACTIVITY_TYPE
                            }
                        };
                        stmt = lrs.addGroupingActivity(stmt, group);


                        let categoryObj = {
                            id: `${xAPIConstants.ACTIVITY_URL_ID}/${xAPIConstants.EXPERIENCE_CODE}`,
                            objectType: 'Activity',
                            definition: {
                                name: {
                                    en: xAPIConstants.EXPERIENC_LABEL
                                },
                                type: xAPIConstants.MODULE_ACTIVITY_TYPE
                            }
                        };
                        stmt = lrs.addCategoryActivity(stmt, categoryObj);

                        lrs.sendStatement(stmt).then(response => {
                            trackingData = Object.assign({}, trackingData, {
                                lrs: lrs,
                                initialised: result.success && result.data == "true" ? true : trackingData.initialised
                            });
                            resolve(trackingData);
                        }).catch(error => {
                            resolve(trackingData);
                        });
                    }

                    getSuspendData();


                }).catch(error => {
                    resolve(trackingData);
                });

            }).catch(error => {
                if (appData.SETTINGS.DEVELOPMENT_MODE) {
                    const student_name = "Lastname, Firstname";
                    let studentNameObj = appHelper.setStudentName(student_name);

                    let settings = {
                        student:{
                            id:'2099009',
                            name: studentNameObj.student_name,
                            homePage: lrs.getCurrentUrl()
                        },
                        activity:{
                            id: `${lrs.getCurrentUrl()}/${contentData.experience.experience_id}`,
                            name: appHelper.getLocalData(contentData.experience).experience_title,
                            description: appHelper.getLocalData(contentData.experience).experience_title,
                        },
                        conf:{
                            endpoint : xAPIConstants.LRS_END_POINT,
                            user:  xAPIConstants.LRS_KEY,
                            password: xAPIConstants.LRS_SECRET,
                        }
                    };
                    lrs.updateSettings(settings);

                    trackingData = Object.assign({}, trackingData, {
                        initialised: true,
                        student_name: studentNameObj.student_name,
                        first_name: studentNameObj.first_name,
                        last_name: studentNameObj.last_name,
                        lrs: lrs,
                    });
                    resolve(trackingData);
                } else {
                    throw(error);
                }

            });

        });
    }
}

export default xAPIScormService;



/** WEBPACK FOOTER **
 ** ./src/services/xAPIScormService.js
 **/